<div
  class="formly-checkbox-wrapper"
  [ngClass]="{ 'work-calendar-checkbox': props.workCalendarClass }"
>
  <div class="checkbox-control pl-1">
    <input #input type="checkbox" [formControl]="formControl" />
  </div>
  <div class="name"><app-i18n [key]="props.name | translate"></app-i18n> </div>
</div>
